export enum SourceType {
    BOOK = "BOOK",
    OWN = "OWN",
}
